import autosize from 'autosize'
import ScrollBooster from 'scrollbooster'
import ClipboardJS from 'clipboard'
import Swal from 'sweetalert2/dist/sweetalert2.js'

function limit(Vue, el, binding, vnode) {
    vnode.context.$emit('input', el.value.slice(0, binding.value))                
    Vue.nextTick(() => {
        autosize.destroy(el);
        autosize(el)
    })
}

export default function install(Vue, options) {
    Vue.directive('focus', {
        inserted(el, binding) {
            if (binding.value === false) return            

            el.focus()
        }
    })

    Vue.directive('alpha-dash', {
        inserted(el, binding, vnode) {
            if (binding.value === false) return

            el.addEventListener('keyup', e => {
                el.value = el.value.replace(/\s+/g, '-')
            })

            el.addEventListener('focus', e => {
                el.value = el.value.replace(/\s+/g, '-')
            })

            el.addEventListener('change', e => {
                el.value = el.value.replace(/\s+/g, '-')
            })
        }
    })

    Vue.directive('alpha-numeric', {
        inserted(el, binding, vnode) {
            if (binding.value === false) return

            el.addEventListener('keydown', e => {
                if (e.keyCode == 32) {
                    e.preventDefault();
                }
            })
        }
    })

    Vue.directive('integer', {
        inserted(el, binding, vnode) {
            if (binding.value === false) {
                return;
            }

            let allowedKeyCodes = [46, 8, 37, 39, 9, 17];
            let allowedControlKeyCodes = [86, 90, 67];
            el.addEventListener('keydown', e => { 
                if(
                    !(e.keyCode >= 48 && e.keyCode <=57) && 
                    !(e.keyCode >= 96 && e.keyCode <=105) &&
                    !allowedKeyCodes.includes(e.keyCode) &&
                    (
                        (
                            allowedControlKeyCodes.includes(e.keyCode) && 
                            e.ctrlKey === false
                        ) ||
                        !allowedControlKeyCodes.includes(e.keyCode)
                    )
                ) {
                    e.preventDefault();
                }
            });
        }
    })

    Vue.directive('float', {
        inserted(el, binding, vnode) {
            if (binding.value === false) {
                return;
            }

            let allowedKeyCodes = [46, 8, 37, 39, 9, 17, 190];
            let allowedControlKeyCodes = [86, 90, 67];
            el.addEventListener('keydown', e => {
                if(
                    !(e.keyCode >= 48 && e.keyCode <=57) && 
                    !(e.keyCode >= 96 && e.keyCode <=105) &&
                    !allowedKeyCodes.includes(e.keyCode) &&
                    (
                        (
                            allowedControlKeyCodes.includes(e.keyCode) && 
                            e.ctrlKey === false
                        ) ||
                        !allowedControlKeyCodes.includes(e.keyCode)
                    )
                ) {
                    e.preventDefault();
                }
            });
        }
    })

    Vue.directive('lowercase', {
        inserted(el, binding, vnode) {
            if (binding.value === false) return

            el.addEventListener('keyup', e => {
                el.value = el.value.toLowerCase()
            })

            el.addEventListener('change', e => {
                el.value = el.value.toLowerCase()
            })
        }
    })

    Vue.directive('titlecase', {
        inserted(el, binding, vnode) {
            if (binding.value === false) return            

            el.addEventListener('keyup', e => {
                if (e.ctrlKey && e.keyCode == 86) {
                    vnode.context.$emit('input', el.value.replace(
                        /\w\S*/g,
                        function(txt) {
                            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                        }
                    ));
                }
            })
        }
    })

    Vue.directive('autosize', {        
        update(el, binding) {
            if (binding.value === false) {
                return
            }

            Vue.nextTick(() => {
                autosize.destroy(el);
                autosize(el)
            })
        }
    })

    Vue.directive('scrollable', {
        inserted(el, binding, vnode) {
            if (binding.value) {
                let content = el.querySelector('table')

                let sb = new ScrollBooster({
                    viewport: el, // this parameter is required
                    content, // scrollable element
                    mode: 'x', // scroll only in horizontal dimension
                    textSelection: true,
                    bounce: false,
                    onUpdate: (data)=> {
                        // your scroll logic goes here
                        content.style.transform = `translateX(${-data.position.x}px)`
                        
                        if (!el.querySelector('.dropdown-menu.show')) {
                            el.classList.add('overflow-x-hidden');
                        } else {
                            el.classList.remove('overflow-x-hidden');
                        }
                    }
                })
            }
        }
    })

    Vue.directive('limit', {        
        inserted(el, binding, vnode) {
            if (!binding.value) {
                return
            }

            el.addEventListener('keydown', e => {
                let allowedKeyCodes = [46, 8, 37, 39, 86, 65, 67];
                if (
                    (
                        !allowedKeyCodes.includes(e.keyCode) || 
                        (e.keyCode == 86 && !e.ctrlKey) || 
                        (e.keyCode == 65 && !e.ctrlKey) ||
                        (e.keyCode == 67 && !e.ctrlKey)
                    ) && 
                    el.value.length >= binding.value                    
                ) {
                    e.preventDefault()
                }
            })

            el.addEventListener('keyup', e => {
                if (e.keyCode !== 17 && !e.ctrlKey) {
                    limit(Vue, el, binding, vnode)
                }
            })

            el.addEventListener('change', e => {
                if (e.keyCode !== 17 && !e.ctrlKey) {
                    limit(Vue, el, binding, vnode)
                }
            })
        }
    })

    Vue.directive('copy', {
        inserted(el) {
            const clipboard = new ClipboardJS(el);

            clipboard.on('success', (e) => {
                Swal.fire({
                    toast: true,
                    position: 'bottom-start',
                    showConfirmButton: false,
                    timer: 3000,
                    type: 'success',
                    title: 'Copied to clipboard',
                })
            })
        }
    })
}